var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSustainablySourced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "41px",
    viewBox: "0 0 49 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sustainably Sourced") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sustainably-Sourced",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 26.0254904 5.86581373 24 10 36.8072743 4.29128507 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,27 C10.7018545,21.6666667 13.6424811,19 16.8218796,19 C20.0012781,19 21.9461013,19.5909796 22.6563492,20.7729388 L28.5880376,20.133393 C29.6862423,20.0149862 30.6725008,20.8092694 30.7909076,21.9074741 C30.7934723,21.9312612 30.7956099,21.9550924 30.7973195,21.9789563 L30.8668781,22.9499127 C30.9418775,23.9968156 30.1948349,24.9235936 29.1558762,25.0725747 L22.6563492,26.0045722 L22.6563492,26.0045722",
    id: "Path-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9329507,21.318308 L43.1414796,14.9339612 C43.9951445,14.4000848 45.1125924,14.5840501 45.7500591,15.3634115 L45.9063362,15.5544744 C46.535269,16.3233786 46.5045293,17.4373625 45.8341622,18.1704232 C41.3767046,23.0447474 38.2229852,26.3102326 36.3730041,27.966879 C33.3619765,30.6632351 32.1504145,32.3935839 28.2669601,32.3935839 C25.6779905,32.3935839 20.5890038,32.929056 13,34",
    id: "Path-16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,17 C27.2689815,14.3333333 28.9356481,13 31,13 C33.0643519,13 34.7310185,13.9359353 36,15.8078059",
    id: "Path-17",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,13 C30.6366478,10.0480126 30.1380309,8.0600158 29.5041493,7.03600948 C28.5533269,5.5 27.933189,4.37303593 27.933189,2.74685458 C27.933189,1.66273368 28.1664077,0.747115487 28.6328452,0",
    id: "Path-18",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0090017,5.63657205 C32.4337693,2.7849707 35.0194084,1.24732478 36.7659189,1.02363429 C38.5124294,0.79994379 39.8919374,1.43436636 40.9044429,2.926902 C41.5756225,4.57555306 40.7805946,5.88037668 38.5193594,6.84137286 C35.1275064,8.28286713 29.2781223,5.56651976 26.3592347,4.65034514 C23.4403472,3.73417052 22.8605326,3.63436945 21.0633497,3.63436945 C19.8652277,3.63436945 18.5418228,4.60855412 17.093135,6.55692345 C16.6053186,7.24776052 16.6053186,7.80641509 17.093135,8.23288718 C17.8248596,8.87259531 20.6340865,10.7254036 22.9358806,9.69369872 C24.47041,9.00589549 26.4947837,7.65351993 29.0090017,5.63657205 Z",
    id: "Path-19",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainablySourced);
export default __webpack_public_path__ + "static/media/sustainablySourced.4cbec71026c867477f7746f4f0c6d1ed.svg";
export { ForwardRef as ReactComponent };